import styled from 'styled-components';
import { colors, monospace2, spacing } from 'ui/theme';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { FullWidth } from 'ui/utility/fullWidth';

export const PageHeading = styled.h1`
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
`;

export const ContentContainer = styled(FullWidth)`
  padding: ${spacing.double} ${spacing.layoutLRPadding};
  background-color: ${colors.backgroundSecondary};
`;

export const Content = styled(FixedWidth)`
  display: flex;
  gap: ${spacing.double};
  
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Identifier = styled.div`
  ${monospace2}
`;

export const PageActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing.half};
`;
